import { createSlice } from '@reduxjs/toolkit';

const initialProductsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  productForView: undefined,
  error: null,
  msg: null,
};
export const callTypes = {
  list: 'list',
  action: 'action',
};

export const productsSlice = createSlice({
  name: 'products',
  initialState: initialProductsState,
  reducers: {
    catchError: (state, action) => {
      //state.error = `${action.type}: ${action.payload.error}`;
      state.error = `${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    sendMsg: (state, action) => {
      state.msg = `${action.payload.msg}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.msg = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findProducts
    productsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.msg = null;
      state.entities = entities;
      state.totalCount = totalCount;
      return state;
    },
    // getProductById
    productFetched: (state, action) => {
      state.actionsLoading = false;
      state.productForView = action.payload.productForView;
      state.error = null;
      state.msg = null;
      return state;
    },
    // create product
    productCreated: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.productForView = action.payload.productForView;
      return state;
    },

    // update product
    productUpdated: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.productForView = action.payload.productForView;
      return state;
    },
    // delete product
    productDeleted: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
      return state;
    },
    // create product
    productCleared: (state, action) => {
      state.error = null;
      state.msg = null;
      state.actionsLoading = false;
      state.productForView = null;
      return state;
    },
  },
});
